import PropTypes from 'prop-types';
import clsx from 'clsx';
import { CssBaseline } from '@mui/material';
import React from 'react';
import {useKeycloak} from '@react-keycloak/web';
import useStyle from './Utils/Style';
import Sidebar from './Sidebar';

const Layout = ({childrenContent, roles, loadingFetchRoles, fetchRoles}) => {
  const classes = useStyle();
  const { keycloak: {authenticated} } = useKeycloak();

    React.useEffect(() => {
        if (authenticated) fetchRoles();
    }, [authenticated]);

  return (
    <div className={clsx(classes.root, 'bg-primaryGray')}>
      <CssBaseline />
      <Sidebar roles={roles} loading={loadingFetchRoles}/>
      <main className="w-main h-full inline-flex">
        {childrenContent}
      </main>
    </div>
  );
};

Layout.defaultProps = {
  roles: null,
  loadingFetchRoles: false,
};

Layout.propTypes = {
  childrenContent: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
    roles: PropTypes.arrayOf(PropTypes.string),
    loadingFetchRoles: PropTypes.bool,
    fetchRoles: PropTypes.func.isRequired,
};

export default Layout;
